// extracted by mini-css-extract-plugin
export default {"wrapper":"FinishStats_wrapper__rm4lH","resultsBlock":"FinishStats_resultsBlock__LeTwo","resultsLink":"FinishStats_resultsLink__-jnPT"};